import React, {useEffect, useState} from 'react'
import ReactDOM from 'react-dom'
import classes from './style.module.scss'
import RightToLeft from '../../../../components/transitions/right-to-left'
import {Iconfont} from "../../../../components/icon/iconfont";
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage, useIntl } from 'react-intl';
import { BlackMask } from '../../../../components/mask';
import { FilterSliders } from '../../../shoppingcart/pages/collect-order/fragments/filter-sorts';

const FilterItem = props => {
	useStyles(classes)
	const { filterItem, value, onChange, itemIndex, isMultiSelect } = props
	const [showTags, setShowTags] = useState(itemIndex > 1 ? false: true)

	const handleClick = (s, fieldName) => {
		const existSelection = value?.selections?.some(selection => selection.value === s.value)
		let newValue
		if(existSelection){
			newValue = {
				...value,
				fieldName,
				selections: isMultiSelect ? value?.selections?.filter(selection => selection.value !== s.value): []
			}
		}else{
			newValue = {
				...value,
				fieldName,
				selections: isMultiSelect ? [...(value?.selections||[]), s]: [s]
			}
		}
		onChange(newValue)
	}

	const isActive = s => {
		return value?.selections?.some?.(selection => selection.value === s.value)
	}

	return <div className={classes.FilterItem}>
		<div className={classes.Hd} onClick={() => setShowTags(!showTags)}>
			{filterItem.title}
			<Iconfont className={`${classes.OpenIcon} ${showTags?classes.Open:''}`}>&#xe7da;</Iconfont>
		</div>
		{
			showTags &&
			<div className={classes.Bd}>
				{
					filterItem?.selections?.map(selection => <span onClick={() =>{handleClick(selection, filterItem.fieldName)}} className={`${classes.Selection} ${isActive(selection)?classes.WishListActive:''}`} key={selection.value}>{selection.label}</span>)
				}
			</div>
		}
		
	</div>
}

const FilterPrice = props => {
	useStyles(classes)
	const {title, priceFilterChange, values, min, max} = props
	const [showTags, setShowTags] = useState(true)

	return (
		<div className={classes.FilterItem}>
			<div className={classes.Hd} style={{marginBottom: 5}} onClick={() => setShowTags(!showTags)}>
				{title}
				<Iconfont className={`${classes.OpenIcon} ${showTags?classes.Open:''}`}>&#xe7da;</Iconfont>
			</div>
			{
				showTags &&
				<FilterSliders
					onChange={values => {priceFilterChange(values)}}
					values={values}
					min={min}
					max={max} />
			}
		</div>
	)
}

const FilterPanel = props => {
	const {filterVo, value, onChange} = props
	const [startPrice, setStartPrice] = useState(0)
	const [endPrice, setEndPrice] = useState(0)
	const [unitPrice, setUnitPrice] = useState()
	const [currencyPrice, setCurrencyPrice] = useState()
	const intl = useIntl()
	useStyles(classes)

	useEffect(() => {
		const priceOfValue = value?.find(v => v?.fieldName == 'price')

		if(filterVo?.filter?.minPrice){
			setUnitPrice(filterVo?.filter?.minPrice?.unit)
			setCurrencyPrice(filterVo?.filter?.minPrice?.currency)
		}
		if(priceOfValue?.startPrice){
			setStartPrice(priceOfValue?.startPrice)
		} else if(filterVo?.filter?.minPrice){
			setStartPrice(filterVo?.filter?.minPrice?.amount)
		}
		if(priceOfValue?.endPrice){
			setEndPrice(priceOfValue?.endPrice)
		} else if(filterVo?.filter?.maxPrice){
			setEndPrice(filterVo?.filter?.maxPrice?.amount)
		}
	},[filterVo, value])

	const getExactValue = fn => {
		return value?.find(v => v.fieldName ===fn)
	}

	const changeHandle = exactValue => {
		const exist = value?.some(v => v.fieldName === exactValue.fieldName)
		let newValue
		if(exist){
			newValue = value?.map(v => {
				if(v.fieldName === exactValue.fieldName){
					return exactValue
				}
				return v
			})
		}else{
			newValue = [...(value||[]), exactValue]
		}

		onChange(newValue)

	}

	const priceFilterChange = ([start, end]) => {
		let newValue = [...(value || [])]
		const priceOfNewValue = newValue?.find(v => v?.fieldName == 'price')
		if(priceOfNewValue){
			let newValueOther = newValue?.filter(n => n?.fieldName != 'price')
			newValueOther.push({
				fieldName: 'price',
				startPrice: start,
				endPrice: end
			})
			onChange(newValueOther)
		} else {
			let priceObj = {
				fieldName: 'price',
				startPrice: start,
				endPrice: end
			}
			newValue.push(priceObj)
			onChange(newValue)
		}
	}

	const formatePrice = (amount) => {
		return {amount: amount, unit: unitPrice, currency: currencyPrice}
	}

	return <div className={classes.FilterItems}>
		{
			filterVo?.filter?.filterItems?.filter(f => f.fieldName !== 'tags' || f.fieldName !== 'price')?.map((filterItem, index) =>
				<FilterItem
					isMultiSelect={filterItem?.isMultiSelect}
					itemIndex={index}
					onChange={changeHandle}
					value={getExactValue(filterItem.fieldName)}
					key={filterItem.fieldName}
					filterItem={filterItem}/>
			)
		}
		{
			filterVo?.filter?.minPrice && filterVo?.filter?.maxPrice &&
			<FilterPrice
				title={intl.formatMessage({id: 'price_range_only', defaultMessage: 'Range Price'})}
				priceFilterChange={values => {priceFilterChange(values)}}
				values={[formatePrice(Number(startPrice)), formatePrice(Number(endPrice))]}
				min={0}
				max={filterVo?.maxPrice?.amount || 0}
				/>
		}
	</div>
}

const PageFilter = props => {
	useStyles(classes)
	const {filterVo, value, handleClear: handleClearProps, showFilter} = props

	const [filterValue, setFilterValue] = useState(value)

	useEffect(() => {
		setFilterValue(value)
	}, [
		JSON.stringify(value),
		showFilter
	])


	const changeHandle = v => {
		setFilterValue(v)
	}

	const handleSubmit = () => {
		props?.onSubmit(filterValue)
	}

	const handleClear = () => {
		// props?.onClear()
		if(handleClearProps){
			setFilterValue([])
			handleClearProps?.()
		} else {
			setFilterValue([])
		}
	}

	return <RightToLeft in={props.showFilter} className={`${classes.FilterPageContainer} ${classes.FilterPageContainerRight}`}>
		<div>
			<div className={`${classes.FilterPage} ${classes.LikeApp}`}>
				<div className={classes.Hd}>
					<Iconfont className={classes.Close} onClick={() => {
						handleClearProps && setFilterValue([])
						props?.onClose()
					}}>&#xe69a;</Iconfont>
					<span><FormattedMessage id="filter" defaultMessage="Filter"/></span>
				</div>
				<div className={classes.Bd}>
					<FilterPanel filterVo={filterVo} value={filterValue} onChange={changeHandle}/>
				</div>
				<div className={classes.Fd}>
					<button onClick={() => {handleClear()}} className={`${classes.OpBtn} ${classes.Delete}`}>
						{/* <FormattedMessage id="clear" defaultMessage="Clear"/> */}
						<Iconfont>&#xe750;</Iconfont>
					</button>
					<button onClick={() => {handleSubmit()}} className={`${classes.OpBtn} ${classes.Active}`}>
						<FormattedMessage id="done" defaultMessage="Done"/>
					</button>
				</div>
			</div>
			{props.showFilter && <BlackMask onClick={() => props?.onClose()}/>}
		</div>
	</RightToLeft>
}


const MemoFilter = React.memo(PageFilter, (prevProps, nextProps) => {
	return JSON.stringify(prevProps) === JSON.stringify(nextProps)
});


export default props => {

	if (typeof window === 'undefined') {
		return null;
	}

	return ReactDOM.createPortal(
		<MemoFilter {...props}/>,
		document.getElementById('root')
	)
}
